export enum MapboxLanguageKey {
  ck3mydmmz0cjx1cpfxuwk39sz = 'af',
  ck3myj91121m91cqpv2yp401l = 'de',
  ck3myjsj12ptq1co3y99mum8p = 'es',
  ck3mykdxw40t01cnyqxxs1sc3 = 'fr',
  ck3myl0ln416d1clt88tcxt88 = 'ja',
  ck3mylles40u71cnyrwoi8gy1 = 'ko',
  ck3mym4dk2pvp1co340o71w9p = 'pt',
  ck3mymq6b1xo11cp0xjcc0qmz = 'ru',
  ck3myeyc521af1crt4854gna7 = 'en',
  ck3myihwo21dy1crto9pqfmy8 = 'zh',
}
